export default "__VITE_PUBLIC_ASSET__bf3515d9__"